export const initialState = {
  mobileSidebarExpanded: false,
  shouldConfirmNavigation: false,
};
